import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { allowListInspect, allowListUpdate } from '@api/sdk.gen';
import { PortainerAllowListKey } from '@api/types.gen';
import type { PortainerAllowList } from '@api/types.gen';

import {
  mutationOptions,
  withError,
  withInvalidate,
} from '@/react-tools/react-query';

const queryKeys = {
  base: () => ['allowlist'] as const,
};

async function getAllowList(): Promise<PortainerAllowList> {
  const { data } = await allowListInspect({
    path: { id: PortainerAllowListKey.ALLOW_LIST_SSRF },
  });
  return data;
}

async function updateAllowList(
  allowList: PortainerAllowList
): Promise<PortainerAllowList> {
  const { data } = await allowListUpdate({
    path: { id: PortainerAllowListKey.ALLOW_LIST_SSRF },
    body: allowList,
  });
  return data;
}

export function useAllowList() {
  return useQuery(queryKeys.base(), getAllowList, {
    ...withError('Unable to retrieve URL allow list'),
  });
}

export function useUpdateAllowListMutation() {
  const queryClient = useQueryClient();

  return useMutation(
    updateAllowList,
    mutationOptions(
      withInvalidate(queryClient, [queryKeys.base()]),
      withError('Unable to update URL allow list')
    )
  );
}
